import {Base} from "@/api/Base"

export class UploadRecordEdit extends Base {
    path = "uploadRecord/edit"
}